import React from 'react';
import { Hero } from '../components/Hero';
import { WhatWeDo } from '../components/WhatWeDo';
import { HowItWorks } from '../components/HowItWorks';
import { Services } from '../components/Services';
import { WhoWeServe } from '../components/WhoWeServe';
import { Pricing } from '../components/Pricing';
import { Resources } from '../components/Resources';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { CtaDivider } from '../components/CtaDivider';
export function HomePage() {
  return <main className="bg-white" data-id="element-407">
      <Hero data-id="element-408" />
      <WhatWeDo data-id="element-409" />
      <HowItWorks data-id="element-410" />
      <Services data-id="element-411" />
      <CtaDivider data-id="element-412" />
      <WhoWeServe data-id="element-413" />
      <Pricing data-id="element-414" />
      <Resources data-id="element-415" />
      <Testimonials data-id="element-416" />
      <FAQ data-id="element-417" />
    </main>;
}